import { render, staticRenderFns } from "./MoveOrderToStatusButton.vue?vue&type=template&id=31100140"
import script from "./MoveOrderToStatusButton.vue?vue&type=script&lang=js"
export * from "./MoveOrderToStatusButton.vue?vue&type=script&lang=js"
import style0 from "./MoveOrderToStatusButton.vue?vue&type=style&index=0&id=31100140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports